import React, {useState} from "react";
import styles from "./Summary.module.scss";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {useCustomerSelector} from "../../../../store";

const SummaryCustomerAccount: React.FC = () => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const {customer} = useCustomerSelector();

  if ((!checkout.isGuest && !isChecked) || customer.isLoggedIn) {
    return null;
  }

  const onChecked = (evt: React.ChangeEvent<HTMLInputElement>) => {
    void checkout.put({isGuest: !evt.target.checked});
    setIsChecked(true);
  };

  return (
    <div className={styles.additionalOption}>
      <h2>{t("checkout.onlyOnePasswordAway")}</h2>
      <label className={styles.additionalOptionLabel} htmlFor="NewCustomerAccountOption">
        <div>
          <input
            className={styles.additionalOptionInput}
            type="checkbox"
            id="NewCustomerAccountOption"
            defaultChecked={isChecked}
            onChange={onChecked}
          />
        </div>
        <p>
          <strong>{t("checkout.createCustomerAccount")}</strong> {t("checkout.benefitFromExclusiveOffers")}
        </p>
      </label>
    </div>
  );
};

export default SummaryCustomerAccount;
